module.exports = __webpack_public_path__ + "img/Frame4377.0def2e58.png";